import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectHasResLinkParamsId } from "../store/experienceSlice";
import "../styles/components/MicrophonePermissionUI.css";

interface MicrophonePermissionUIProps {
  accessRequired: boolean;
  onMicrophoneButtonClick?: () => void;
}

const MicrophonePermissionUI: React.FC<MicrophonePermissionUIProps> = ({
  accessRequired = true,
  onMicrophoneButtonClick = () => console.log("Enable Microphone Access button clicked"),
}) => {
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const hasResLink = useSelector(selectHasResLinkParamsId);

  useEffect(() => {
    setButtonDisabled(false);
  }, []);

  const handleClick = () => {
    setButtonDisabled(true);
    onMicrophoneButtonClick();
  };

  return (
    <div className="lobby-container">
      <button className="enable-microphone-button" onClick={handleClick} disabled={buttonDisabled}>
        {accessRequired ? "Enable microphone access" : hasResLink ? "Rejoin Conversation" : "Start"}
      </button>
    </div>
  );
};

export default MicrophonePermissionUI;
